var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intergration",
    d: "M63.822,56.574h-1.2a.087.087,0,0,1-.087-.087V53.145a1.681,1.681,0,0,0-1.681-1.681H57.515a.087.087,0,0,1-.087-.087v-1.2A2.166,2.166,0,0,0,55.324,48a2.143,2.143,0,0,0-2.181,2.142v1.232a.087.087,0,0,1-.087.087H49.714A1.72,1.72,0,0,0,48,53.178v3.045a.087.087,0,0,0,.087.087h1.164a2.425,2.425,0,0,1,.035,4.846h-1.2a.087.087,0,0,0-.087.087v3.045A1.72,1.72,0,0,0,49.714,66H52.76a.087.087,0,0,0,.087-.087V65.01a2.485,2.485,0,0,1,2.38-2.469,2.289,2.289,0,0,1,2.466,2.176v1.2a.087.087,0,0,0,.087.087h3.078a1.681,1.681,0,0,0,1.681-1.681V60.946a.087.087,0,0,1,.087-.087h1.232a2.143,2.143,0,1,0-.035-4.285Z",
    transform: "translate(-47.25 -47.252)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationMenuIcon);
export default __webpack_public_path__ + "static/media/integration-menu-icon.9a17583981f30dd43302e4f876071cf0.svg";
export { ForwardRef as ReactComponent };